(function () {
   'use strict';

   module.exports = AssetCoreMedia;
   var helper = require('../helpers/generic.js');
   var logger = new (require('../helpers/logger.js'))("AssetCoreMedia").setColor("gold");
   var settings = require('../helpers/settings.js');

  function AssetCoreMedia(detailJson){
    this.json = detailJson;
  }

  AssetCoreMedia.prototype = {
    _languageDetails: function _languageDetails(){
      function firstKey(obj) {
        for(var key in obj)
          return key;
      }

      if (helper.undefOrNull(this.json) || helper.undefOrNull(this.json.languages) || this.json.languages.length <= 0){
          throw "AssetCoreMedia: incorrect json: " + this.json;
      }
      var curLang = settings.currentLanguage();
      var fallbackLang = settings.fallbackLanguage();
      var langData = this.json.languages[curLang];
      if (helper.undefOrNull(langData) && curLang!=fallbackLang){
        logger.debug("using fallback language for details: ", fallbackLang);
        langData = this.json.languages[fallbackLang];
      }
      if (helper.undefOrNull(langData)){
        var firstLang = firstKey(this.json.languages);
        logger.debug("using first available language '"+firstLang+"' for details (no default '"+curLang+"' or fallback '"+fallbackLang+"' available!): ", firstLang);
        langData = this.json.languages[firstLang];
      }
      if (helper.undefOrNull(langData)){
        throw "AssetCoreMedia: No language-details found in JSON; Neither for currentLanguage ('"+curLang+"') nor for fallbackLanguage ('"+fallbackLang+"')!";
      }

      return langData;
    },
    provider: function provider(qualityName){
      var q = null;
      if (helper.undefOrNull(qualityName)){
        q = this._languageDetails().qualities[this.defaultQualityName()];
      } else {
        q = this._languageDetails().qualities[qualityName];
      }
      if (helper.undefOrNull(q)){
        return null;
      } else {
        return q.provider;
      }
    },
    defaultQualityName: function defaultQualityName(){
      return this._languageDetails().defaultQuality;
    },
    type: function type(){
      return this.json.type;
    },
    _defaultQuality: function _defaultQuality(){
      return this._getQuality(this.defaultQualityName());
    },
    _getQuality: function getQuality(qName){
      var q = this._languageDetails().qualities[qName];
      if (helper.undefOrNull(q)){
        return null;
      } else {
        return q;
      }
    }
  };

}());



//////////////////
// WEBPACK FOOTER
// ./src/AssetCore/media.js
// module id = 8
// module chunks = 0